<form
  [formGroup]="form"
  (submit)="userLogin()"
  autocomplete="off"
  class="p-4 p-md-5 shadow bg-light h-100"
>
  <small class="fw-semibold">Login</small>
  <div class="text-danger" *ngIf="showLoginError">{{ loginError }}</div>
  <div class="form-floating my-3">
    <input
      type="text"
      formControlName="username"
      class="form-control"
      id="username"
      placeholder="Login"
      [ngClass]="{ 'is-invalid': submitted && theForm['username'].errors }"
    />
    <label for="username">Login</label>
    <div
      *ngIf="submitted && theForm['username'].errors"
      class="invalid-feedback"
    >
      <div *ngIf="theForm['username'].errors['required']">
        Username is required
      </div>
    </div>
  </div>
  <div class="form-floating mb-3">
    <input
      type="password"
      formControlName="password"
      class="form-control"
      id="password"
      placeholder="Password"
      [ngClass]="{ 'is-invalid': submitted && theForm['password'].errors }"
    />
    <label for="password">Password</label>
    <div
      *ngIf="submitted && theForm['password'].errors"
      class="invalid-feedback"
    >
      <div *ngIf="theForm['password'].errors['required']">
        Password is required
      </div>
    </div>
  </div>
  <div class="text-end mb-3">
    <a
      class="text-info text-decoration-none"
      [routerLink]="['/forgot-password']"
      >Forgot Password?</a
    >
  </div>

  <button class="btn btn-primary" [disabled]="loading" type="submit">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
    Login
  </button>
  <hr class="my-4" />
  <a class="text-dark text-decoration-none" [routerLink]="['/register']">Register</a>
</form>
